import styled from 'styled-components'

export const Container = styled.div`
  width: 100vw;
  height: 100vh;

  overflow: hidden;
`

export const Main = styled.main`
  height: calc(100vh - 93px);
  margin-left: 93px;
  margin-top: 93px;

  overflow-y: auto;
  overflow-x: hidden;

  position: relative;

  @media (max-width: 650px) {
    margin-left: 0;
  }
`
